<template>
  <div id="app">
    <div class="container is-fullhd">
    <section>
      <nav class="navbar" role="navigation" aria-label="main navigation"
           style="box-shadow: 0 2px 3px hsla(0,0%,7%,.1), 0 0 0 1px hsla(0,0%,7%,.1)">
        <div class="navbar-brand ">
          <a class="navbar-item is-logo has-text-centered">
            <img style="max-height: 2.75em; height: 2.75em; width: 10em;" src="./assets/cleverid.png"/>
          </a>
        </div>
      </nav>
    </section>

    <div v-if="events.length < 1" class="columns" style="margin: 0;">
      <div class="column has-text-centered">
        <div style="padding-top: 40px">
          <i style="font-size:8em;" class="far fa-user"></i>
          <h3 style="font-weight: bold; padding-top: 15px">No issues detected</h3>
        </div>
      </div>
    </div>

    <div v-if="events.length != 0" class="columns has-text-centered" style="margin: 20px 10px 10px 10px;">
      <a class="button" style="width: 100%" @click="clear">Clear all</a>
    </div>
  <section class="hero is-medium ">
    <div v-if="events.length > 0" class="rows" style="margin: 2000;">
      <div :key="idx" v-for="(event, idx) in events" class="row">
        <div class="card" style="margin: 20px 10px 10px 10px;">
          <div class="card-content" style="overflow: hidden">
            <div class="media" style="overflow: hidden">
              <div class="media-content has-text-centered" style="overflow: hidden">
                <p class="title is-4 has-text-danger" v-if="event.status == 2">Member not known</p>
                <p class="title is-4 has-text-warning" v-if="event.status == 1">Issue with Membership</p>
                <p class="title is-4 has-text-success" v-if="event.status == 0">Member Identified</p>
                <p class="title is-4" v-if="event.status != 2"> {{ event.name }} {{ event.surname }}</p>
                <p class="title is-4" v-if="event.status != 2"> {{ event.membership }}</p>
                <p style="margin-bottom: 10px" class="title is-4">Seen at {{ event.area }}</p>
                <p class="title is-4"> {{ event.time }} </p>
              </div>
            </div>
          </div>
          <div class="card-image columns has-text-centered" >
            <div class="column has-text-centered is-half">
              <figure class="image is-4by3" style="margin-right: 10px; margin-left: 10px">
                <img :src="'data:image/png;base64,' + event.detection" alt="Placeholder image" >
              </figure>
            </div>
            <div class="column has-text-centered is-half" v-if="event.status != 2">
              <figure class="image is-4by3" style="margin-right: 10px; margin-left: 10px">
                <img :src="'data:image/png;base64,' + event.enrolment" alt="Placeholder image" >
              </figure>
            </div>
          </div>

          <footer class="card-footer">
            <!--<a href="#" class="card-footer-item">Save</a>-->
            <a @click="remove(idx)" class="card-footer-item">Delete</a>
          </footer>
        </div>
      </div>
    </div>
  </section>  
    </div>
    <div class="modal is-active" v-if="showModal">
      <div class="modal-background"></div>
      <div class="modal-card">
          <section class="modal-card-body has-text-dark has-text-centered">
            <h1 class="title"> Welcome to CleverID </h1>
            <br>
              <button class="button is-info is-rounded is-large" v-on:click="startEvents()">Get started</button>
          </section>
      </div>
    </div>
      <div class="modal is-active" v-if="showModalEvent">
      <div class="modal-background"></div>
      <div class="modal-card">
            <header class="modal-card-head">
            <p class="modal-card-title">{{cardtitle}}</p>
            <button class="delete" aria-label="close" @click="closeModal"></button>
          </header>
          <section class="modal-card-body has-text-dark">
            <div class="card" style="margin: 20px 10px 10px 10px;">
              <div class="card-content" style="overflow: hidden">
                <div class="media" style="overflow: hidden">
                  <div class="media-content has-text-centered" style="overflow: hidden">
                    <p class="title is-4 has-text-danger" v-if="modalevent.status == 2">Member not known</p>
                    <p class="title is-4 has-text-warning" v-if="modalevent.status == 1">Issue with Membership</p>
                    <p class="title is-4 has-text-success" v-if="modalevent.status == 0">Member Identified</p>
                    <p class="title is-4" v-if="modalevent.status != 2"> {{ modalevent.name }} {{ modalevent.surname }}</p>
                    <p class="title is-4" v-if="modalevent.status != 2"> {{ modalevent.membership }}</p>
                    <p style="margin-bottom: 10px" class="title is-4">Seen at {{ modalevent.area }}</p>
                    <p class="title is-4"> {{ modalevent.time }} </p>
                  </div>
                </div>
              </div>
              <div class="card-image columns has-text-centered" >
                <div class="column has-text-centered is-half">
                  <figure class="image is-4by3" style="margin-right: 10px; margin-left: 10px">
                    <img :src="'data:image/png;base64,' + modalevent.detection" alt="Placeholder image" >
                  </figure>
                </div>
                <div class="column has-text-centered is-half" v-if="modalevent.status != 2">
                  <figure class="image is-4by3" style="margin-right: 10px; margin-left: 10px">
                    <img :src="'data:image/png;base64,' + modalevent.enrolment" alt="Placeholder image" >
                  </figure>
                </div>
              </div>
              </div>
            </section>
          </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
  import axios from 'axios';
  export default {
    name: 'App',
    data() {
      return {
        events: [],
        last_event_id: 2,
        areas: [],
        fr_alert: false,
        allowance: "Unknown member",
        type: 'na',
        event_id: 0,
        area: 'Gym',
        token: '',
        showModal: true,
        showModalEvent: false,
        modalevent: null,
        allowclosemodal: true,
        timeout: null,
        cardtitle: '',
      };
    },
    created() {
      
    },
    methods: {
      startEvents(){
        const config = { headers: { 'api_token': '&j4erert43rlufwe3kjd3%js7?*.fowqmdyf%', 'token': this.token} };
        let id = JSON.parse(localStorage.getItem("lastid" + this.type + this.area));
        if(id !== undefined && id !== 0 && id !== null){
          axios.get('https://cc-api-service.cleverenrol.com/api/ccl/natfit/dc/eventslist?id=' + id, config)
            .then((res) => {
              if(res.status == 200){
                let events = res.data;
                if(events.length > 0){
                  var i;
                  for (i = 0; i < events.length; i++) {
                    this.showEvent(events[i], false, false);
                  }
                  localStorage.setItem("lastid" + this.type + this.area, JSON.stringify(events[events.length - 1]));
                }
              }
            })
            .catch((err) => {
              console.log('message', err.response);
            })
        }
        else{
            axios.get('https://cc-api-service.cleverenrol.com/api/ccl/natfit/dc/eventslist?id=0', config)
            .then((res) => {
              if(res.status == 200){
                let ev = res.data;
                this.showEvent(ev[0], false, false);
                localStorage.setItem("lastid" + this.type + this.area, JSON.stringify(ev[0]));
              }
            })
            .catch((err) => {
              console.log('message', err.response);
            })
        }

        this.$cidHub.$on('cid-changed', this.onNewEvent);
        this.showModal = false;

      },
      showEvent(id, sound, card){
        const config = { headers: { 'api_token': '&j4erert43rlufwe3kjd3%js7?*.fowqmdyf%', 'token': this.token} };
        axios.get('https://cc-api-service.cleverenrol.com/api/ccl/natfit/dc/events?id=' + id, config)
          .then((res) => {
            if(res.status == 200){
                try{
                  let event = res.data;
                  // console.log(event);
                  // console.log(this.area);
                  if(event.area != this.area){
                    return;
                  }
                  event.time = event.time.toString();
                  if(this.type === 'na'){
                    if(event.status == 2){
                      event.membership = "Unknown";
                      event.name = "Unknown";
                      event.surname = "Unknown";
                      this.events.unshift(event);
                      if(card){
                        this.modalevent = event;
                        this.cardtitle = "New event at " + event.area;
                        this.showModalEvent = true; 
                      }

                      if(sound){
                        var audio = new Audio(require('./assets/noti.wav'));
                        audio.play();
                      }
                      clearTimeout(this.timeout);
                      this.timeout = setTimeout(() => {
                        if(this.showModalEvent){
                          this.showModalEvent = false;
                          this.modalevent = null;
                        }
                      }, 10000);
                    }
                    else if(event.status == 1){
                      this.events.unshift(event);
                      if(card){
                        this.modalevent = event;
                        this.cardtitle = "New event at " + event.area;
                        this.showModalEvent = true; 
                      }
                      if(sound){
                        var audio = new Audio(require('./assets/noti.wav'));
                        audio.play();
                      }
                      clearTimeout(this.timeout);
                      this.timeout = setTimeout(() => {
                        if(this.showModalEvent){
                          this.showModalEvent = false;
                          this.modalevent = null;
                        }
                      }, 10000);
                    }
                  }
                  else{
                    if(event.status != 2){
                      this.events.unshift(event);
                      if(card){
                        this.modalevent = event;
                        this.cardtitle = "New event at " + event.area;
                        this.showModalEvent = true; 
                      }
                      if(sound){
                        var audio = new Audio(require('./assets/noti.wav'));
                        audio.play();
                      }
                      clearTimeout(this.timeout);
                      this.timeout = setTimeout(() => {
                        if(this.showModalEvent){
                          this.showModalEvent = false;
                          this.modalevent = null;
                        }
                      }, 10000);
                    }
                  }
                  localStorage.setItem("events" + this.type + this.area, JSON.stringify(this.events));
                } catch(err) {
                  console.error(err);
                }
              // console.log(res.data);
            }
          })
          .catch((err) => {
            console.log('message', err.response);
          })
      },
      closeModal(){
        this.showModalEvent = false;
        this.modalevent = null;
        clearTimeout(this.timeout);
      },
      onNewEvent({id}){
        this.event_id = id;
        const vm = this;
        localStorage.setItem("lastid" + this.type + this.area, JSON.stringify(this.event_id));
        this.showEvent(this.event_id, true, true);
      },
      remove(idx) {
        const ok = confirm('Do you want to remove this unknown person from your list?');
        if (ok) {
          this.events.splice(idx, 1);
          localStorage.setItem("events" + this.type + this.area, JSON.stringify(this.events));
        }
      },
      clear() {
        const ok = confirm('Are you sure you want to remove all of the events from the list?');
        if (ok) {
          this.events = [];
          localStorage.setItem("events" + this.type + this.area, JSON.stringify(this.events));
        }
      },
      // notifyMe() {
      //   // Let's check if the browser supports notifications
      //   if (!("Notification" in window)) {
      //     alert("This browser does not support desktop notification");
      //   }

      //   // Let's check whether notification permissions have already been granted
      //   else if (Notification.permission === "granted") {
      //     // If it's okay let's create a notification
      //     var notification = new Notification("Hi there!");
      //   }

      //   // Otherwise, we need to ask the user for permission
      //   else if (Notification.permission !== "denied") {
      //     Notification.requestPermission().then(function (permission) {
      //       // If the user accepts, let's create a notification
      //       if (permission === "granted") {
      //         var notification = new Notification("Hi there!");
      //       }
      //     });
      //   }

      //   // At last, if the user has denied notifications, and you 
      //   // want to be respectful there is no need to bother them any more.
      // }
    },
    mounted(){

      let uri = window.location.search.substring(1);
      let params = new URLSearchParams(uri);
      let c = params.get("type");
      if(c !== null){
        this.type = params.get("type");
      }
      let a = params.get("area");
      if(a !== null){
        this.area = params.get("area");
      }
      let t = params.get("pass");
      if(t !== null){
        this.token = params.get("pass");
      }
      this.events = JSON.parse(localStorage.getItem("events" + this.type + this.area)) || [];
    }
    // mounted() {
    //   let uri = window.location.search.substring(1); 
    //   let params = new URLSearchParams(uri);
    //   let c = params.get("type");
    //   if(c !== null){
    //     this.type = params.get("type");
    //   }
    //   // Check browser supports HTML5 local storage
    //   if (typeof(Storage) === "undefined") {
    //     alert('ERROR: Please open the application in a supported browser, like chrome.')
    //   }

    //   // Load the events from the local storage
    //   this.events = JSON.parse(localStorage.getItem("events")) || [];

    //   let sock = null;
    //   let ellog = null;
    //   const vm = this;
    //   window.onload = function () {
    //     axios.get('https://localhost/dceventservice/api/events/checkhertahealth')
    //     .then((res)=> {
    //       if(res.status == 200){
    //         if(res.data == false){
    //           window.alert("Facial recognition seems to be down. Check if Herta is connected.");
    //           this.fr_alert = true;
    //         }
    //       }
    //     })
    //     .catch((err) => {
    //       console.error(err);
    //       console.log('message', err.response);
    //     });
    //     axios.get('https://localhost/dceventservice/api/events/getlasteventid')
    //     .then((res) => {
    //       if(res.status == 200){
    //         this.last_event_id = res.data;
    //         //this.last_event_id = 1;
    //         console.log(res.data);
    //       }
    //     })
    //     .catch((err) => {
    //       console.error(err);
    //       console.log('message', err.response);
    //     });
    //     axios.get('https://localhost/dceventservice/api/gates/getareas')
    //     .then((res) => {
    //       if(res.status == 200){
    //         this.areas = res.data;
    //         console.log(res.data);
    //       }
    //     })
    //     .catch((err) => {
    //       console.error(err);
    //       console.log('message', err.response);
    //     })
    //   };
    //   var interval = setInterval(function(){
    //     for(var i = 0; i < this.areas.length; i++){
    //       axios.get('https://localhost/dceventservice/api/events/geteventssinceid/?id=' + this.last_event_id + '&area=' + this.areas[i])
    //       .then((res) => {
    //         if(res.status == 200){
    //           this.fr_alert = false;
    //           var data = res.data.item1;
    //           this.last_event_id = res.data.item2;
    //           for(var i = 0; i < data.length; i++){
    //             try{
    //               let event = data[i];
    //               if(this.type === 'na'){
    //                 if(event.status == 2){
    //                   //BEEP
    //                   // var audio = new Audio(require('./assets/alarm.mp3'));
    //                   // audio.play();
    //                   event.member = "";
    //                   event.allowance = "Unknown member";
    //                 }
    //                 else if(event.status == 1){
    //                   // var audio = new Audio(require('./assets/alarm.mp3'));
    //                   // audio.play();
    //                   event.allowance = "Membership issue";
    //                 }
    //               }
    //               else{
    //                 if(event.status == 0){
    //                   //BEEP
    //                   // var audio = new Audio(require('./assets/alarm.mp3'));
    //                   // audio.play();
    //                   event.allowance = "Member Identified";
    //                 }
    //                 else if(event.status == 1){
    //                   // var audio = new Audio(require('./assets/alarm.mp3'));
    //                   // audio.play();
    //                   event.allowance = "Membership issue";
    //                 }
    //               }

    //               vm.events.push(event);
    //               localStorage.setItem("events", JSON.stringify(vm.events));
    //               // var audio = new Audio(require('./assets/alarm.mp3'));
    //               // audio.play();
    //             } catch(err) {
    //               console.error(err);
    //             }
    //           }
    //           console.log(res.data);
    //         }
    //       })
    //       .catch((err) => {
    //         if(!this.fr_alert){
    //           window.alert("Connection with facial recognition lost. Please, check if Herta is running.")
    //           console.error(err);
    //           console.log('message', err.response);
    //           this.fr_alert = true;
    //         }
    //       })
    //     }
    //   }, 5000);
    // },
  };
</script>

<style>
  /* // @import '~bulma/bulma'; */

  .navbar-item {
      width: 100%;
      display: inline-block;
      text-align: center;
  }

  .navbar-item.is-logo {
      padding-left: calc(50% - 11em);
  }

</style>



// WEBPACK FOOTER //
// src/App.vue